import { render, staticRenderFns } from "./TemplateMessageAddNewModal.vue?vue&type=template&id=259c4ca2&"
import script from "./TemplateMessageAddNewModal.vue?vue&type=script&lang=js&"
export * from "./TemplateMessageAddNewModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMessageAddNewModal.vue?vue&type=style&index=0&id=259c4ca2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports